export interface Testimonial {
  name: string
  initials: string
  role: string
  messages: string[]
  time: string
}

/** Recensioni di esempio: sostituirle con messaggi reali degli allenatori. */
export const testimonials: Testimonial[] = [
  {
    name: 'Marco Ferretti',
    initials: 'MF',
    role: 'Allenatore Under 14 · Bologna',
    messages: [
      'Ieri ho usato per la prima volta una seduta del Volume 1.',
      "L'ho preparata in 5 minuti in macchina prima dell'allenamento. Ragazzi sempre in movimento, zero tempi morti.",
    ],
    time: '21:47',
  },
  {
    name: 'Giulia Rinaldi',
    initials: 'GR',
    role: 'Allenatrice settore giovanile · Padova',
    messages: [
      'Il Gruppi Misti Toolkit mi ha salvata.',
      'Ho 18 bambini con livelli diversissimi: stesso esercizio, tre varianti, e finalmente lavorano tutti.',
    ],
    time: '19:12',
  },
  {
    name: 'Andrea Colombo',
    initials: 'AC',
    role: 'Allenatore Under 17 · Conversano',
    messages: [
      'Le Correzioni Express le tengo stampate in panchina.',
      "Vedo l'errore, leggo il cue, lo dico al ragazzo. Spiego meno e loro capiscono di più.",
    ],
    time: '23:05',
  },
]
